import classnames from 'classnames'
import { useTranslation } from 'next-i18next'

import { useStatsigDynamicLocaleConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-locale-config.hook'

import { ReadMore } from '../readMore'
import ReviewMetaRow from '../reviews/reviewMetaRow/ReviewMetaRow'
import ReviewStars from '../reviews/reviewStars'

import styles from './productReviewHighLight.module.scss'
import stylesV2 from './productReviewHighlightV2.module.scss'

import type { ReviewMetaRowProps } from '../reviews/reviewMetaRow/ReviewMetaRow'

export interface ProductReviewHighLightProps extends ReviewMetaRowProps {
  title: string
  avgRating: number
  children: string
  className?: string
  brandName?: string
  newPdpv2?: boolean
  /** Suppress the divider on the last card — no trailing border needed */
  isLast?: boolean
}

const ProductReviewHighLight = ({
  children,
  className,
  avgRating,
  title,
  brandName,
  newPdpv2,
  isLast,
  reviewedInCountry,
  isIncentivized,
  rewardProgrammeLearnMoreUrl,
}: ProductReviewHighLightProps) => {
  const { t } = useTranslation('common')
  const localeConfig = useStatsigDynamicLocaleConfig()
  const finalStyles = newPdpv2 ? stylesV2 : styles

  const hasMeta = localeConfig.displayLocalisedReviewSize && (reviewedInCountry || Boolean(isIncentivized))
  const classes = classnames(finalStyles.container, className, {
    [finalStyles['container--withDivider'] ?? '']: hasMeta && !isLast && !newPdpv2,
  })

  return (
    <div className={classes}>
      <ReviewStars totalStars={5} fillStars={avgRating} />
      <div className={finalStyles.container__title}>{title}</div>
      <ReadMore className={finalStyles.container__body}>{children}</ReadMore>
      {brandName && (
        <p className={finalStyles.brandName}>
          {t('customer_review_from')} {brandName}
        </p>
      )}
      <ReviewMetaRow
        reviewedInCountry={reviewedInCountry}
        isIncentivized={isIncentivized}
        rewardProgrammeLearnMoreUrl={rewardProgrammeLearnMoreUrl}
      />
    </div>
  )
}
export default ProductReviewHighLight
